import { MouseEvent, useEffect, useRef } from "react";
import { messaging } from "../../../firebase";
import { iNotificationPayloadData, iNotificationRowModel } from "../../../types/notificationTypes";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/storeHooks";
import { isSafari } from "../../../utils/commonUtils";
import { onMessage } from "firebase/messaging";
import {
	markReadNotification,
	refreshNotificationsThunk,
} from "../../../store/notifications/notificationThunk";
import { ROUTE_QUERY_PARAMS } from "../../../routes";
import {
	NOTIFICATION_TYPES,
	notificationCategoryOf,
	notificationTagOf,
} from "../../../constants/notificationConstant";
import { getAccessToken } from "../../../helpers/authHelpers";
import { useOnUpdateUserNotifications } from "../../../hooks/firestoreHooks/notificationUpdated";
import { useToast } from "../../../context/ToasterContext";
import { notificationUrlOf } from "../../../utils/notificationUtils";

const toastFromPushData = (data: iNotificationPayloadData): iNotificationRowModel => {
	const category = notificationCategoryOf({ category: data.notificationCategory, type: data.type });
	return {
		id: data.notficationId,
		category,
		type: data.type,
		tag: notificationTagOf(category, data.type),
		eventName: data.eventName,
		eventLabel: data.eventLabel || null,
		title: data.title,
		body: data.richDescription ?? data.body,
		isRead: true,
		createdAt: new Date().toISOString(),
		url: notificationUrlOf(data),
	};
};

const NotificationsForgroundListner = () => {
	const { showNotificationToast } = useToast();
	const dispatch = useAppDispatch();
	const location = useLocation();

	const queryParams = new URLSearchParams(location.search);
	const notificationId = queryParams.get(ROUTE_QUERY_PARAMS.NOTIFICATION_ID);

	const showToastFor = (toast: iNotificationRowModel) =>
		showNotificationToast(toast, (event: MouseEvent<HTMLAnchorElement>) => {
			if (toast.id) dispatch(markReadNotification(toast.id));
			if (
				window.location.href.split("?")[0] === new URL(toast.url, window.location.origin).href.split("?")[0]
			) {
				event.preventDefault();
				window.location.href = toast.url;
			}
		});
	const showToastRef = useRef(showToastFor);
	useEffect(() => {
		showToastRef.current = showToastFor;
	});

	useEffect(() => {
		if (notificationId) {
			dispatch(markReadNotification(notificationId));
		}
	}, [dispatch, notificationId]);

	useEffect(() => {
		if (messaging && !isSafari()) {
			onMessage(messaging, (payload) => {
				const data = payload.data as unknown as iNotificationPayloadData | null;
				if (NOTIFICATION_TYPES.NEW_MESSAGE === data?.type && data?.url === window.location.href) {
					return;
				}
				if (data?.title && data.body && data.type) {
					showToastRef.current(toastFromPushData(data));
				}
			});
		}
	}, []);

	const getNotifications = () => {
		if (getAccessToken()) {
			dispatch(refreshNotificationsThunk());
		}
	};

	useOnUpdateUserNotifications(getNotifications);

	return null;
};

export default NotificationsForgroundListner;
